import { useMutation, useQuery } from "@apollo/client";
import { useAuth } from "providers/AuthProvider";
import { gql } from "types";

export const PROFILE = gql(/* GraphQL */ `
  query Profile {
    user {
      id
      email
      isMfaEnabled
      passwordUpdatedAt
      profile {
        id
        name
        preferredName
      }
      userTours {
        id
        type
        step
        lastClickedAt
      }
    }
  }
`);

const UPSERT_PROFILE = gql(/* GraphQL */ `
  mutation UpsertProfile($input: ProfileInput!) {
    upsertProfile(input: $input) {
      id
      name
      preferredName
    }
  }
`);

export const useProfile = () => {
  const { data, error, loading } = useQuery(PROFILE);
  const user = data?.user;
  const profile = user?.profile;
  const userTours = user?.userTours;

  const [upsertProfile, { loading: loadingUpsertProfile }] = useMutation(
    UPSERT_PROFILE,
    {
      refetchQueries: [{ query: PROFILE }],
    },
  );

  return {
    user,
    profile,
    userTours,
    loading,
    error,
    upsertProfile,
    loadingUpsertProfile,
  };
};

export const useMfa = () => {
  const { authState } = useAuth();

  const generateMfa = async (password: string) => {
    const host = process.env.REACT_APP_API_BASE_URL;
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: authState?.accessToken || "",
      },
      body: JSON.stringify({ password }),
    };
    const response = await fetch(`${host}mfa/generate`, requestOptions);
    if (response.status !== 201) {
      const json = await response.json();
      throw new Error(json.message);
    }
    return await response.arrayBuffer();
  };

  return {
    generateMfa,
  };
};
